import {NullAsDefault} from "views/Shared";
import React from 'react'

export const NavigationContext = React.createContext(
  {
    canBack: false,
    history: {},
    location: {},
    mainLocation: {},
    routesConfig: {},
    modalRoutesConfig: {},
    handleGoBack: NullAsDefault,
    isModal: false
  }
)
